<div class="page-title" [ngStyle]="{background: 'url('+ background +') center center no-repeat'}">
	<h1 class="title">{{ title }}</h1>
	<h2 class="sub-title">{{ subTitle }}</h2>
</div>
